var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col mt-4"},[_c('ul',[_c('div',{class:['relative', 'mt-2', 'mx-6', 'pb-1'],attrs:{"role":"heading","aria-level":"2"}},[_c('div',{staticClass:"text-body-extra-small mx-2 text-highway-300 dark:text-white-300"},[_vm._v(_vm._s(_vm.__('Suggestions')))]),_vm._v(" "),_c('div',{class:[
          'separator',
          'transition-all',
          'absolute',
          'left-0',
          'right-0',
          'bottom-0',
          'border-0',
          'border-b-0.5',
          'border-solid',
          'border-highway-disabled',
          'dark:border-white-disabled' ],attrs:{"role":"separator"}})]),_vm._v(" "),_vm._l((_vm.searchSuggestions),function(suggestion,index){return _c('li',{key:'suggestion_' + index,class:[
        'relative',
        'px-6',
        'text-17',
        'selection-none',
        'outline-none',
        'bg-transparent',
        'cursor-pointer',
        'transition',
        'group' ],attrs:{"tabindex":"0"},on:{"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.searchFor(suggestion)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }return _vm.searchFor(suggestion)}],"click":function($event){return _vm.searchFor(suggestion)}}},[_c('div',{class:['py-1', 'text-highway-100', 'dark:text-white-100']},[_c('div',{staticClass:"px-2 py-2 rounded-lg hover-hover:group-hover:bg-light-ui-200 hover-hover:dark:group-hover:bg-dark-ui-200 hover-hover:group-focus:bg-light-ui-200 hover-hover:dark:group-focus:bg-dark-ui-200"},[_vm._v("\n          "+_vm._s(suggestion)+"\n        ")])]),_vm._v(" "),_c('div',{class:[
          'separator',
          'transition-all',
          'absolute',
          'left-6',
          'right-6',
          'border-0',
          'border-b-0.5',
          'border-solid',
          'border-highway-disabled',
          'dark:border-white-disabled' ],attrs:{"role":"separator"}})])})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }